import React, { Suspense, lazy, useEffect } from "react";
const AuthHome = lazy(() => import('../intermediate_modules/auth/auth_home'));
import { useNavigate, Routes, Route } from 'react-router';


const LoginRoutes = () => {
    const navigate = useNavigate();
    const navigateTo = (data) => { 
        navigate(data.detail.route, { state: data.detail }); 
    };

    useEffect(() => {
        document.addEventListener("LOS_NAVIGATE", navigateTo);
        return () => {
            document.removeEventListener("LOS_NAVIGATE", navigateTo);
        }
    }, [navigate])

    return <>
        <Suspense fallback={<>Loading...</>}>
            <Routes>
                {/* {
                    ["/", "/login"].map(path => <Route path={path} element={<AuthHome />} />)
                } */}
                <Route path="*" element={<AuthHome />} />
            </Routes>
        </Suspense>
    </>


}

export default LoginRoutes;